import { render, staticRenderFns } from "./BecameAMember.vue?vue&type=template&id=e289c2dc&scoped=true&"
import script from "./BecameAMember.vue?vue&type=script&lang=js&"
export * from "./BecameAMember.vue?vue&type=script&lang=js&"
import style0 from "./BecameAMember.vue?vue&type=style&index=0&id=e289c2dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e289c2dc",
  null
  
)

export default component.exports